import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../providers/AuthContext';

const DEPARTAMENTOS = [
  'Montevideo',
  'Artigas',
  'Canelones',
  'Cerro Largo',
  'Colonia',
  'Durazno',
  'Flores',
  'Florida',
  'Lavalleja',
  'Maldonado',
  'Paysandú',
  'Río Negro',
  'Rivera',
  'Rocha',
  'Salto',
  'San José',
  'Soriano',
  'Tacuarembó',
  'Treinta y Tres'
];

const BuyerForm = ({ onChange, shippingType, errors = {} }) => {
  const { user, loading } = useContext(AuthContext);
  const [nombre, setNombre] = useState('');
  const [mail, setMail] = useState('');
  const [cedula, setCedula] = useState('');
  const [direccion, setDireccion] = useState('');
  const [ciudad, setCiudad] = useState('');
  const [departamento, setDepartamento] = useState('Montevideo');
  const [codigoPostal, setCodigoPostal] = useState('');
  const [telefono, setTelefono] = useState('');
  const [referencias, setReferencias] = useState('');
  
  const isPickup = shippingType === 'retiro_local';

  // Precargar datos cuando el usuario esté logueado
  useEffect(() => {
    if (user && !loading) {
      const googleName = user.displayName || '';
      const googleEmail = user.email || '';
      
      setNombre(googleName);
      setMail(googleEmail);
      
      // Notificar al componente padre con los datos precargados
      onChange({
        nombre: googleName,
        mail: googleEmail,
        cedula: '',
        direccion: '',
        ciudad: '',
        departamento: 'Montevideo',
        codigoPostal: '',
        telefono: '',
        referencias: ''
      });
    }
  }, [user, loading]);

  // Enviar datos iniciales al componente padre cuando se monte el componente
  useEffect(() => {
    onChange({
      nombre,
      mail,
      cedula,
      direccion,
      ciudad,
      departamento,
      codigoPostal,
      telefono,
      referencias
    });
  }, []);

  // Función para validar los datos y pasar los valores al componente padre
  const handleInputChange = (field, value) => {
    // Actualizamos el estado local
    if (field === 'nombre') setNombre(value);
    if (field === 'mail') setMail(value);
    if (field === 'cedula') setCedula(value);
    if (field === 'direccion') setDireccion(value);
    if (field === 'ciudad') setCiudad(value);
    if (field === 'departamento') setDepartamento(value);
    if (field === 'codigoPostal') setCodigoPostal(value);
    if (field === 'telefono') setTelefono(value);
    if (field === 'referencias') setReferencias(value);

    // Informamos al componente padre con los valores actuales
    onChange({
      nombre: field === 'nombre' ? value : nombre,
      mail: field === 'mail' ? value : mail,
      cedula: field === 'cedula' ? value : cedula,
      direccion: field === 'direccion' ? value : direccion,
      ciudad: field === 'ciudad' ? value : ciudad,
      departamento: field === 'departamento' ? value : departamento,
      codigoPostal: field === 'codigoPostal' ? value : codigoPostal,
      telefono: field === 'telefono' ? value : telefono,
      referencias: field === 'referencias' ? value : referencias,
    });
  };

  return (
    <div className="buyer-form-content" style={{ padding: '20px 24px' }}>
      {user && !loading && (
        <div style={{ 
          padding: '12px 16px', 
          marginBottom: '20px', 
          background: '#f8f8f8', 
          border: '1px solid #eee',
          fontSize: '0.78rem',
          color: '#555',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <i className="fas fa-info-circle" style={{ color: '#999' }}></i>
          Datos precargados desde tu cuenta de Google. Puedes modificarlos si es necesario.
        </div>
      )}
      <div className="mb-3">
        <label style={{ fontSize: '0.72rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>Nombre:</label>
        <input
          type="text"
          className={`form-control ${errors.nombre ? 'is-invalid' : ''}`}
          value={nombre}
          onChange={(e) => handleInputChange('nombre', e.target.value)}
          placeholder={!user ? "Ingresa tu nombre completo" : ""}
          style={{ borderRadius: 0, fontSize: '0.88rem', border: '1px solid #ddd', padding: '10px 14px' }}
        />
      </div>
      <div className="mb-3">
        <label style={{ fontSize: '0.72rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>Correo electrónico:</label>
        <input
          type="email"
          className={`form-control ${errors.mail ? 'is-invalid' : ''}`}
          value={mail}
          onChange={(e) => handleInputChange('mail', e.target.value)}
          placeholder={!user ? "ejemplo@correo.com" : ""}
          style={{ borderRadius: 0, fontSize: '0.88rem', border: '1px solid #ddd', padding: '10px 14px' }}
        />
      </div>
      <div className="mb-3">
        <label style={{ fontSize: '0.72rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>Cédula:</label>
        <input
          type="text"
          className={`form-control ${errors.cedula ? 'is-invalid' : ''}`}
          value={cedula}
          onChange={(e) => handleInputChange('cedula', e.target.value)}
          placeholder="Ingresa tu número de cédula"
          style={{ borderRadius: 0, fontSize: '0.88rem', border: '1px solid #ddd', padding: '10px 14px' }}
        />
      </div>

      {isPickup ? (
        <>
          <div style={{ 
            padding: '14px 16px', 
            marginBottom: '16px', 
            background: '#f8f8f8', 
            border: '1px solid #eee',
            fontSize: '0.82rem',
            color: '#1a1a1a'
          }}>
            <div style={{ fontWeight: '600', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <i className="fa-solid fa-store" style={{ color: '#999' }}></i>
              Retiro en Local
            </div>
            <p className="mb-0" style={{ fontSize: '0.78rem', color: '#888' }}>Tu pedido estará disponible para retirar en nuestra tienda. Te contactaremos cuando esté listo.</p>
          </div>
          
          <div className="mb-3">
            <label style={{ fontSize: '0.72rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>
              Teléfono de contacto: <span style={{ color: '#c00' }}>*</span>
            </label>
            <input
              type="tel"
              className={`form-control ${errors.telefono ? 'is-invalid' : ''}`}
              value={telefono}
              onChange={(e) => handleInputChange('telefono', e.target.value)}
              placeholder="Número de teléfono para avisarte cuando esté listo"
              style={{ borderRadius: 0, fontSize: '0.88rem', border: '1px solid #ddd', padding: '10px 14px' }}
            />
          </div>
        </>
      ) : (
        <>
          <div style={{ 
            fontSize: '0.78rem', 
            fontWeight: '600', 
            textTransform: 'uppercase', 
            letterSpacing: '0.08em', 
            color: '#1a1a1a', 
            marginTop: '8px', 
            marginBottom: '16px',
            paddingBottom: '8px',
            borderBottom: '1px solid #eee',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <i className="fa-solid fa-location-dot" style={{ color: '#999' }}></i>
            Dirección de envío
          </div>
          
          <div className="mb-3">
            <label style={{ fontSize: '0.72rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>
              Dirección completa: <span style={{ color: '#c00' }}>*</span>
            </label>
            <input
              type="text"
              className={`form-control ${errors.direccion ? 'is-invalid' : ''}`}
              value={direccion}
              onChange={(e) => handleInputChange('direccion', e.target.value)}
              placeholder="Calle, número, apartamento, etc."
              style={{ borderRadius: 0, fontSize: '0.88rem', border: '1px solid #ddd', padding: '10px 14px' }}
            />
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label style={{ fontSize: '0.72rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>
                Ciudad/Localidad: <span style={{ color: '#c00' }}>*</span>
              </label>
              <input
                type="text"
                className={`form-control ${errors.ciudad ? 'is-invalid' : ''}`}
                value={ciudad}
                onChange={(e) => handleInputChange('ciudad', e.target.value)}
                placeholder="Ciudad o localidad"
                style={{ borderRadius: 0, fontSize: '0.88rem', border: '1px solid #ddd', padding: '10px 14px' }}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{ fontSize: '0.72rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>
                Departamento: <span style={{ color: '#c00' }}>*</span>
              </label>
              <select
                className="form-select"
                value={departamento}
                onChange={(e) => handleInputChange('departamento', e.target.value)}
                style={{ borderRadius: 0, fontSize: '0.88rem', border: '1px solid #ddd', padding: '10px 14px' }}
              >
                {DEPARTAMENTOS.map(dep => (
                  <option key={dep} value={dep}>{dep}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label style={{ fontSize: '0.72rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>Código postal:</label>
              <input
                type="text"
                className="form-control"
                value={codigoPostal}
                onChange={(e) => handleInputChange('codigoPostal', e.target.value)}
                placeholder="Código postal (opcional)"
                style={{ borderRadius: 0, fontSize: '0.88rem', border: '1px solid #ddd', padding: '10px 14px' }}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label style={{ fontSize: '0.72rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>
                Teléfono de contacto: <span style={{ color: '#c00' }}>*</span>
              </label>
              <input
                type="tel"
                className={`form-control ${errors.telefono ? 'is-invalid' : ''}`}
                value={telefono}
                onChange={(e) => handleInputChange('telefono', e.target.value)}
                placeholder="Número de teléfono"
                style={{ borderRadius: 0, fontSize: '0.88rem', border: '1px solid #ddd', padding: '10px 14px' }}
              />
            </div>
          </div>

          <div className="mb-3">
            <label style={{ fontSize: '0.72rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.08em', color: '#1a1a1a', marginBottom: '6px', display: 'block' }}>Referencias de ubicación:</label>
            <input
              type="text"
              className="form-control"
              value={referencias}
              onChange={(e) => handleInputChange('referencias', e.target.value)}
              placeholder="Ej: Casa azul, frente a la plaza, etc. (opcional)"
              style={{ borderRadius: 0, fontSize: '0.88rem', border: '1px solid #ddd', padding: '10px 14px' }}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default BuyerForm;
